import { stringToNumber } from '@23degrees/shared-code/data/utilities';
import { formatField } from './formatField';
import { DataRow } from '@23degrees/shared-code/models';

interface DeltaInsertOp {
  insert: any;
  attributes: any;
}

export class InlineValue {
  deltaOp: DeltaInsertOp;
  fieldName?: string;

  protected constructor(deltaOp: DeltaInsertOp) {
    this.deltaOp = deltaOp;
    this.fieldName = deltaOp.insert?.value?.fieldName;
  }

  static create = (deltaOp: DeltaInsertOp) => {
    return new InlineValue(deltaOp);
  };

  public resolveFields = (
    dataContext: DataRow,
    fallbackStr = 'No data available',
    content?: any,
    customFormat: Record<string, string | number> | null = null,
  ): string => {
    let inlineStr = '';
    const options = this.deltaOp.insert.value;

    const { fieldName, format } = options;

    if (!this.fieldName || !dataContext || dataContext[this.fieldName] === undefined || dataContext[this.fieldName] === null) {
      inlineStr = fallbackStr; // content?.typeSpecific.noDataMessages?.inline;
    } else {
      let inputLocale = 'de-DE';
      const inputField = content?.typeSpecific.fields[fieldName];
      if (inputField) {
        inputLocale = inputField.format.locale;
      }

      let data = dataContext[this.fieldName];
      if (customFormat && customFormat.formatType === 'number') {
        const { value } = stringToNumber(<string | number>data, <string>customFormat.locale);
        const error = Number.isNaN(value || 0 - Number.parseFloat(`${value}`));
        if (!error && value) data = value;
      }

      const fieldFormat = customFormat ? customFormat : format;
      inlineStr = formatField(data, fieldFormat, true, inputLocale);
    }

    // assure return type is a string;
    return `${inlineStr}`;
  };
}
